module.exports = __webpack_public_path__ + "static/media/desktop-footer.c74dc1d8.svg";